module.exports = __webpack_public_path__ + "static/media/logo-old.c66f8abb.png";